<template>
  <v-container fluid class="px-1 py-1">
    <CommonCardList
        title="Material"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/Material/MaterialDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:card.body="{item}">
        {{item.version}}
      </template>
    </CommonCardList>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useCardListStore} from "@/components/Common/CommonCardList";
import CommonTable from "@/components/Common/CommonTable";
import MaterialDetail from "@/components/CoreMaterial/Material/MaterialDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CommonCardList from "@/components/Common/CommonCardList";

export default {
  name: "MaterialTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'MaterialTable'},
    dtoDetailQuery: {default: 'MaterialDetailQueryDTO'},
    detailStoreName: {default: 'MaterialDetail'},
    dtoValidateCommand: {type: [String], default: 'MaterialValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    MaterialDetail,
    BaseFieldCheck,
    CommonCardList,
  },

  methods: {
  },


  mounted() {
    this.storeCardList = useCardListStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    if (!!this.storeCardList) {
      this.storeCardList.dtoDetailQuery = this.dtoDetailQuery
      this.storeCardList.dtoListQuery = this.dtoListQuery
      this.storeCardList.dtoActionCommand = this.dtoActionCommand
      this.storeCardList.options.sortBy = ['created_on']
    }
  },

  data() {
    return {
      storeCardList: null,
    }
  },
}
</script>

<style scoped>

</style>